// extracted by mini-css-extract-plugin
export var description = "banner-module--description--mYhQr";
export var fs = "banner-module--fs--LX5K+";
export var image = "banner-module--image--BXMpq";
export var imageDesktop = "banner-module--imageDesktop--Jilmy";
export var imageMobile = "banner-module--imageMobile--liRCr";
export var lg = "banner-module--lg--SRaum";
export var md = "banner-module--md--zGbx+";